// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"03c06586","513":"16c1b20b","703":"40abcdba","787":"4a55bd14"}[chunkId] + ".chunk.js";
};